import { createStyles, Typography, withStyles } from '@material-ui/core';
import React from 'react';
import { TypographyAllProps } from 'globals/types';

const FsHeaderMedium = withStyles(() =>
  createStyles({
    root: {
      fontWeight: 700,
    },
  })
)((props: TypographyAllProps) => (
  <Typography variant="h2" component="h2" {...props} />
));

export default FsHeaderMedium;
